import { ColorController } from "controllers";
import { withMultiColorSelectHOC } from "shared/HOC";

const ColorSelectButtons = withMultiColorSelectHOC(ColorController.getColors());
export default ColorSelectButtons;
